import { Family } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getFamilies = async (
  familyIds: (string | number)[],
  locale: string
): Promise<Family[]> => {
  const url = `/family/filter?ids=${familyIds.join('|')}&include=available&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<Family[]>(url);
  return response.data;
};
